import React from 'react'
import styled from 'styled-components'

import dynamic from 'next/dynamic'
import WhyUseUs from '~/components/traffic-tickets/WhyUseUs'
import DesktopContainer from '~/components/DesktopContainer'
import WinItButton from '~/components/WinItButton'
import PlusIcon from '~/components/svg/PlusIcon'
import Spacer from '~/components/Spacer'
import WinItBackgroundLogos from '~/components/WinItBackgroundLogos'
import ElfGoogleReviews from '~/components/_integrations/ElfGoogleReviews'
import withTranslations from '~/components/_hocs/withTranslations'

const WhyUsModal = dynamic(() => import('./WhyUsModal'))

const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: ${(props) => props.theme.fonts.avenirNextBold};
`

const Close = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  padding-left: 8px;
  padding-right: 8px;
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  flex-grow: 0;
`

const CloseText = styled.div`
  padding-left: 8px;
`

const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  overflow: hidden;
`

const Title = styled.h2`
  text-align: center;
`

class WhyUsContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      open: false,
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({ open: !this.state.open })
  }

  render() {
    // Add wrapper: if logo underlay is not needed just return children passed to wrapper
    const Wrapper = this.props.noUnderlay
      ? ({ children }) => [children]
      : WinItBackgroundLogos
    const { currentHost, isWILawAffiliated, translate } = this.props
    return (
      <>
        <BackgroundContainer>
          <Wrapper>
            <DesktopContainer>
              <MainContainer>
                <ElfGoogleReviews />
                {!isWILawAffiliated && (
                  <>
                    {!this.props.noTitle && (
                      <Title>{translate('title')}</Title>
                    )}
                    <Spacer mobile={30} desktop={60} />
                    <WhyUseUs currentHost={currentHost} />
                  </>
                )}
                <Spacer mobile={40} desktop={80} />
                {!this.props.noModal && (
                  <>
                    <WinItButton
                      color='white'
                      height={44}
                      shape='round'
                      fontSize='16px'
                      width='160px'
                      onClick={this.toggle}
                    >
                      <Close>
                        <PlusIcon color='#3089F3' size='12px' />
                        <CloseText>{translate('learnMore')}</CloseText>
                      </Close>
                    </WinItButton>
                    <Spacer mobile={40} desktop={80} />
                    <WhyUsModal isOpen={this.state.open} toggle={this.toggle} />
                  </>
                )}
              </MainContainer>
            </DesktopContainer>
          </Wrapper>
        </BackgroundContainer>
      </>
    )
  }
}

export default withTranslations(WhyUsContainer, 'traffic.whyUseUs')
